"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _constant = require("./constant");
var _PassengerChip = _interopRequireDefault(require("./PassengerChip.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PassengerChipContainer = _styledComponents.default.div.withConfig({
  displayName: "PassengerChip__PassengerChipContainer",
  componentId: "sc-fwwylh-0"
})(["background-color:", ";border-radius:", ";justify-content:center;align-items:center;display:flex;padding:1px;"], function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return color ? theme.colors[color] : theme.colors.secondaryLight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius.normal;
});
var IconStyle = _styledComponents.default.div.withConfig({
  displayName: "PassengerChip__IconStyle",
  componentId: "sc-fwwylh-1"
})(["display:inline-flex;margin:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.space.micro);
});
var TextStyle = _styledComponents.default.div.withConfig({
  displayName: "PassengerChip__TextStyle",
  componentId: "sc-fwwylh-2"
})(["display:inline-flex;margin:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return "1px ".concat(theme.space.tiny, " 1px 1px");
});
var PassengerChip = function PassengerChip(props) {
  var paxCount = props.paxCount,
    color = props.color,
    backgroundColor = props.backgroundColor,
    iconSize = props.iconSize,
    theme = props.theme,
    accessible = props.accessible,
    customProperties = props.customProperties;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(PassengerChipContainer, (0, _extends2.default)({
      tabIndex: tabIndex,
      color: backgroundColor,
      "aria-label": "passenger count ".concat(paxCount)
    }, customProperties, {
      accessible: accessible
    }), /*#__PURE__*/_react.default.createElement(IconStyle, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: color || _constant.ICON_INFO.COLOR,
      fontsize: iconSize || _constant.ICON_INFO.SIZE,
      icon: _constant.ICON_INFO.ICON,
      theme: theme,
      accessible: false
    })), /*#__PURE__*/_react.default.createElement(TextStyle, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: color || _constant.ICON_INFO.COLOR,
      type: _constant.TEXT_INFO.TYPE,
      theme: theme,
      bold: true,
      accessible: false
    }, paxCount)));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
PassengerChip.propTypes = _PassengerChip.default.PropTypes;
PassengerChip.defaultProps = _PassengerChip.default.DefaultProps;
var _default = PassengerChip;
exports.default = _default;